export enum ShowFiltersDefinition {
  False = 0,
  True = 10,
}
